module.exports = __webpack_public_path__ + "static/media/Materials and draft resolutions.8cc2a43d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2019/Materials and draft resolutions.pdf
// module id = 126
// module chunks = 0